import React from 'react';

import './coming-soon.styles.scss';

export default function ComingSoon() {
  return (
    <div className='coming-soon-container'>
      <h1>Climate Indicators for Forestry</h1>
      <h4>Coming soon</h4>

      <div className='site-screenshot-container'>
        <img src={process.env.PUBLIC_URL + '/assets/site-screenshot.png'} alt='Screenshot of site that will be located here' />
      </div>
    </div>
  );
}